import React, { useCallback, useEffect } from 'react'
import { ReactElement } from 'react'

import Currency from '../../../../../../../../../1stlog-ui/src/components/Currency'
import CurrencyInput from '../../../../../../../../../1stlog-ui/src/components/CurrencyInput'
import useFieldState from '../../../../../../../../../1stlog-ui/src/components/Field/useFieldState'
import useFieldValue from '../../../../../../../../../1stlog-ui/src/components/Field/useFieldValue'

type TCurrencyOption = {
  label: string
  readonly?: boolean
  serviceName: string
}

const CurrencyOption = (props: TCurrencyOption): ReactElement => {
  const { label, readonly, serviceName } = props

  const [value, setValue] = useFieldState<number>('value.value')
  const [currency, setCurrency] = useFieldState<string>('value.currency')

  console.log('CurrencyOption', { label, serviceName, value, currency })

  const validate = useCallback(
    (value, allValues) => {
      if (serviceName === 'INS') {
        const vogValue = allValues?.valueOfGoods?.value
        if (vogValue || vogValue === 0) {
          if (vogValue < value) {
            return i18n.t(
              'insurance_cannot_be_higher_than_value_of_goods',
              'Die Versicherungssumme darf nicht höher sein als der Warenwert',
            )
          }
        }
      }
    },
    [serviceName],
  )

  const valueOfGoodsValue: number = useFieldValue('valueOfGoods.value', {
    ignorePrefix: true,
  })
  console.log('valueOfGoodsValue', valueOfGoodsValue)
  useEffect(() => {
    if (serviceName === 'INS') {
      setTimeout(() => {
        setValue(valueOfGoodsValue || 0)
      }, 0)
    }
  }, [])

  const valueOfGoodsCurrency: string = useFieldValue('valueOfGoods.currency', {
    ignorePrefix: true,
  })
  useEffect(() => {
    if (serviceName === 'INS') {
      setTimeout(() => {
        setCurrency(valueOfGoodsCurrency || 'EUR')
      }, 0)
    }
  }, [valueOfGoodsCurrency])

  return (
    <div>
      {readonly && <Currency value={value} currency={currency} />}
      <div hidden={readonly}>
        <CurrencyInput
          name="value"
          label={label}
          allowZeroValue
          disableCurrency={serviceName === 'INS'}
          validate={validate}
        />
      </div>
    </div>
  )
}

export default CurrencyOption
